// // TermsAndConditions.js
// import React, { useEffect, useState } from 'react';
// import { Container, Spinner, Alert } from 'react-bootstrap';
// import axios from 'axios';

// const TermsAndConditions = () => {
//   const [terms, setTerms] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchTerms = async () => {
//         const token=localStorage.getItem('admin_token')
//         console.log(token);
//       try {

//         const response = await axios.get('https://toptennis.io/api/admin/Termstext', {
//           headers: {
//             authorization: `Bearer ${token}` // or however you're storing the token
//           }
//         });
//         console.log(response.data,"data");

//         setTerms(response.data[0].content);
//       } catch (err) {
//         setError('Failed to load Terms and Conditions.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTerms();
//   }, []);

//   return (
//     <Container className="my-4">
//       <h2 className="mb-4">Terms and Conditions</h2>
//       {loading && <Spinner animation="border" />}
//       {error && <Alert variant="danger">{error}</Alert>}
//       {!loading && !error && (
//         <div dangerouslySetInnerHTML={{ __html: terms }} />
//       )}
//     </Container>
//   );
// };

// export default TermsAndConditions;
// TermsAndConditions.js
import React, { useEffect, useState } from "react";
import { Container, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import { useLoader } from "../loader/LoaderContext";

const TermsAndConditions = () => {
  const [terms, setTerms] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchTerms = async () => {
      const token = localStorage.getItem("admin_token");
      try {
        showLoader();
        const response = await axios.get(
          "https://toptennis.io/api/user/termText",
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        setTerms(response.data[0].content);
      } catch (err) {
        setError("Failed to load Terms and Conditions.");
      } finally {
        setLoading(false);
        hideLoader();
      }
    };

    fetchTerms();
  }, []);

  return (
    <Container className="pt-4 px-3 px-md-5">
      <h2 className="mb-4">Terms and Conditions</h2>
      {loading && <Spinner animation="border" />}
      {error && <Alert variant="danger">{error}</Alert>}
      {!loading && !error && (
        <div dangerouslySetInnerHTML={{ __html: terms.replace(/\n/g, '<br/>') }} />
      )}
    </Container>
  );
};

export default TermsAndConditions;
